// Official IMMOBILART logo — raster wordmark served from /public.
// Pass `width` for a width-constrained logo (height auto) or `height` for a height-constrained one.
// Never force both dimensions (keeps original proportions, object-fit: contain).
export function Logo({ height, width, className = "", title = "IMMOBILART" }) {
  const style = width
    ? { width, height: "auto", maxWidth: "100%", objectFit: "contain", display: "block" }
    : { height: height || 28, width: "auto", maxWidth: "none", objectFit: "contain", flexShrink: 0, display: "block" };
  return (
    <img
      src="/logo-immobilart.webp"
      alt={title}
      title={title}
      data-testid="immobilart-logo"
      style={style}
      className={className}
    />
  );
}

export default Logo;

// Brand icon: solid pink circle (no border, no symbol, transparent background).
export function BrandIcon({ size = 26, className = "", title = "IMMOBILART" }) {
  return (
    <span
      role="img"
      aria-label={title}
      title={title}
      data-testid="brand-icon"
      className={className}
      style={{ display: "inline-block", width: size, height: size, borderRadius: "9999px", background: "#FC82ED", flexShrink: 0 }}
    />
  );
}
